import Constants from '@/constants'

class SidMessage {
  constructor({
    Identifier = null,
    GroupName = null,
    RequestType = null,
    InstructionType = null,
    IsProcessing = false,
    Message = '',
    Options = {},
  }) {
    this._id = Identifier
    this._transactionId = GroupName
    this._requestType = RequestType
    this._instructionType = InstructionType
    this._options = Options
    this._isProcessing = IsProcessing
    this._message = Message
  }

  get id() {
    return this._id
  }

  get transactionId() {
    return this._transactionId
  }

  get requestType() {
    return this._requestType
  }
  set requestType(value) {
    this._requestPage = value
  }

  get instructionType() {
    return this._instructionType
  }
  set instructionType(value) {
    this._instructionType = value
  }

  get options() {
    return this._options
  }

  get isProcessing() {
    return this._isProcessing
  }
  set isProcessing(value) {
    this._isProcessing = value
  }

  get message() {
    return this._message
  }
  set message(value) {
    this._message = value
  }

  getRequest() {
    return {
      messageId: this._id,
      message: this._message,
      requestType: this._requestType,
      options: this._options,
      transactionId: this._transactionId,
      isProcessing: this._isProcessing,
    }
  }

  getInstruction() {
    return {
      messageId: this._id,
      message: this._message,
      instructionType: this._instructionType,
      options: this._options,
      transactionId: this._transactionId,
      isProcessing: this._isProcessing,
    }
  }

  getRequestPage() {
    return Constants.requestPages[this._requestType]
  }

  getInstructionPage() {
    return Constants.instructionPages[this._instructionType]
  }

  isCancelled() {
    return this._instructionType === Constants.instructionTypes.CANCELLED
  }

  isCompleted() {
    return this._instructionType === Constants.instructionTypes.COMPLETED
  }

  isMessage() {
    return this._instructionType === Constants.instructionTypes.MESSAGE
  }

  isBehaviourNone() {
    return this._instructionType === Constants.instructionTypes.BEHAVIOURNONE
  }
}

export default SidMessage
